import { render, staticRenderFns } from "./selection-actions-menu.vue?vue&type=template&id=2d7b3864&scoped=true&"
import script from "./selection-actions-menu.vue?vue&type=script&lang=js&"
export * from "./selection-actions-menu.vue?vue&type=script&lang=js&"
import style0 from "./selection-actions-menu.vue?vue&type=style&index=0&id=2d7b3864&scoped=true&lang=css&"
import style1 from "./selection-actions-menu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b3864",
  null
  
)

export default component.exports